import { UpdateUser } from 'domain/usecases/user/update-user'
import { UserRepository } from 'repository/repositories/user/user-repository'

export class RemoteUpdateUser implements UpdateUser {
  private readonly userRepository: UserRepository

  constructor(userRepository: UserRepository) {
    this.userRepository = userRepository
  }

  update(params: UpdateUser.Params): Promise<UpdateUser.Model> {
    return this.userRepository.updateUser(params)
  }
}
